import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import CardItem from '../../common/card/card';
import getCard from '../../common/drawCard/getCard';

function CardLeft() {
	const chosenCard = useSelector((state) => state.leftPlayer.chosenCard);
	const { show, suit, card } = chosenCard;

	useEffect(() => {
		getCard('leftcard', 'card_left');
	}, [chosenCard]);
	return show ? (
		<div id="leftcard">
			<CardItem suit={suit} card={card} downCard="card_left" />
		</div>
	) : (
		<div id="leftcard"></div>
	);
}

export default CardLeft;
